import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import React__default, { useMemo, useState, useRef } from "react";
import { useConfig } from "../../../contexts/config-context.js";
import { useTranslation } from "../../../contexts/translation-context.js";
import { deserialize } from "../helpers.js";
import { HoursInput } from "./hours-input.js";
import { MinutesInput } from "./minutes-input.js";
import { classes } from "./time-input.st.css";
const TimeInput = ({
  disabled,
  use24Hours,
  placeholder,
  onChange,
  onNext,
  minutesRef = React__default.createRef(),
  value,
  readOnly,
  inputId
}) => {
  const { t } = useTranslation();
  const { isRTL: rtl } = useConfig();
  const [HH, MM] = useMemo(() => placeholder?.split(":") || [], [placeholder]);
  const [tempHours, setTempHours] = useState(void 0);
  const { hours, minutes, period } = deserialize(value, use24Hours);
  const hoursRef = useRef(null);
  const hoursAriaBy = `hours-${inputId}`;
  const minutesAriaBy = `minutes-${inputId}`;
  const focusOnHours = (key) => {
    hoursRef.current?.focus();
    if (key === "Backspace" && hours !== void 0) {
      const newHours = hours.substring(0, hours.length - 1);
      setTempHours(newHours);
    }
  };
  const handleHoursNext = (_, isNumber) => {
    if (isNumber) {
      minutesRef.current?.setSelectionRange(
        0,
        minutesRef.current?.value.length
      );
    }
    minutesRef.current?.focus();
  };
  const handleMinutesChange = (newMinutes) => {
    onChange(hours, newMinutes);
  };
  const handleHoursChange = (newHours, newPeriod) => {
    setTempHours(newHours);
    onChange(newHours, minutes, newPeriod);
  };
  return /* @__PURE__ */ jsxs("div", { className: classes.root, children: [
    /* @__PURE__ */ jsx(
      HoursInput,
      {
        ref: hoursRef,
        value: tempHours ?? hours,
        placeholder: HH,
        use24Hours,
        disabled,
        readOnly,
        period,
        "aria-describedby": hoursAriaBy,
        className: classNames(classes.hours, { [classes.rtl]: rtl }),
        onChange: handleHoursChange,
        onNext: handleHoursNext,
        onFocus: () => setTempHours(hours),
        onBlur: () => setTempHours(void 0)
      }
    ),
    /* @__PURE__ */ jsx(
      "span",
      {
        "aria-hidden": true,
        className: classNames(classes.colon, {
          [classes.colonDisabled]: disabled
        }),
        children: ":"
      }
    ),
    /* @__PURE__ */ jsx(
      MinutesInput,
      {
        ref: minutesRef,
        placeholder: MM,
        value: minutes,
        disabled,
        readOnly,
        "aria-describedby": minutesAriaBy,
        className: classNames(classes.minutes, { [classes.rtl]: rtl }),
        onChange: handleMinutesChange,
        onPrev: focusOnHours,
        onNext
      }
    ),
    /* @__PURE__ */ jsx("span", { id: hoursAriaBy, className: classes.hiddenA11y, children: t("field.time.label.hours") }),
    /* @__PURE__ */ jsx("span", { id: minutesAriaBy, className: classes.hiddenA11y, children: t("field.time.label.minutes") })
  ] });
};
export {
  TimeInput
};
//# sourceMappingURL=time-input.js.map
